export enum OrderLockSystemStatus {
  Created = 0,
  Started = 1,
  Ready = 2,
  Submitted = 3,
  Completed = 4,
  QuoteSubmitted = 5,
  Deleted = 6,
  Canceled = 7,
}

export namespace OrderLockSystemStatus {
  export function isDraft(status: number): boolean {
    return (
      status === OrderLockSystemStatus.Created ||
      status === OrderLockSystemStatus.Started ||
      status === OrderLockSystemStatus.Ready
    );
  }

  export function toString(status: number): string {
    return isDraft(status) ? "Draft" : OrderLockSystemStatus[status];
  }
}
